export const drawProductImage = (canvas, image, { mode, crop, scale = 100, background = 'transparent' }, size = 1200) => {
  const width = image.naturalWidth;
  const height = image.naturalHeight;
  if (!width || !height) throw new Error('The image has not loaded yet.');

  const region = mode === 'crop' && crop
    ? {
        x: width * crop.x / 100,
        y: height * crop.y / 100,
        width: width * crop.width / 100,
        height: height * crop.height / 100,
      }
    : { x: 0, y: 0, width, height };
  if (region.width <= 0 || region.height <= 0) throw new Error('Choose a crop area first.');

  canvas.width = size;
  canvas.height = size;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Your browser could not prepare this image.');
  context.clearRect(0, 0, size, size);
  if (background !== 'transparent') {
    context.fillStyle = background;
    context.fillRect(0, 0, size, size);
  }
  const fit = size / Math.max(region.width, region.height) * (mode === 'fit' ? scale / 100 : 1);
  const drawnWidth = region.width * fit;
  const drawnHeight = region.height * fit;
  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = 'high';
  context.drawImage(image, region.x, region.y, region.width, region.height,
    (size - drawnWidth) / 2, (size - drawnHeight) / 2, drawnWidth, drawnHeight);
};

export const exportProductImage = async (image, options, filename = 'product') => {
  const canvas = document.createElement('canvas');
  drawProductImage(canvas, image, options);
  const encode = () => new Promise((resolve, reject) => {
    canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Could not save the image.')), 'image/png');
  });
  let blob = await encode();
  // Keep the generated file inside the existing upload limit, even for noisy images.
  if (blob.size > 5 * 1024 * 1024) {
    drawProductImage(canvas, image, options, 1000);
    blob = await encode();
  }
  if (blob.size > 5 * 1024 * 1024) throw new Error('The cropped image is too large to upload.');
  return new File([blob], `${filename.replace(/\.[^.]+$/, '')}-cropped.png`, { type: 'image/png' });
};
